(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("pixi.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "pixi.js"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react-dom"), require("pixi.js")) : factory(root["React"], root["ReactDOM"], root["PIXI"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_11__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(9);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(4);
	var raf = __webpack_require__(5);
	
	var Canvas = React.createClass({
	    displayName: 'Canvas',
	
	
	    propTypes: {
	
	        width: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.oneOf(['auto'])]),
	        height: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.oneOf(['auto'])]),
	        engines: React.PropTypes.object,
	        engine: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.func]),
	
	        tick: React.PropTypes.bool,
	
	        onTick: React.PropTypes.func,
	        onReady: React.PropTypes.func,
	        onSizeChange: React.PropTypes.func
	    },
	
	    getDefaultProps: function () {
	        return {
	            engine: 'pixi',
	            engines: {},
	            width: 'auto',
	            height: 'auto',
	            tick: true
	        };
	    },
	
	    getInitialState: function () {
	        return {
	            ready: false,
	            width: this.props.width !== 'auto' ? this.props.width : 0,
	            height: this.props.height !== 'auto' ? this.props.height : 0,
	            engineTick: null
	        };
	    },
	
	    render: function () {
	        var engine = this.renderEngine();
	
	        return engine;
	    },
	
	    renderEngine: function () {
	        var Engine = typeof this.props.engine === 'function' ? this.props.engine : this.getEngineByName(this.props.engine);
	
	        return React.createElement(
	            Engine,
	            _extends({}, this.props, {
	                width: this.state.width,
	                height: this.state.height,
	                onReady: this.onEngineReady,
	                onTickReady: this.onEngineTickReady }),
	            this.props.children
	        );
	    },
	
	    /**
	     * Life cycle
	     */
	    componentDidMount: function () {
	        if (this.props.width === 'auto' || this.props.height === 'auto') {
	            this.updateSize();
	        }
	
	        window.addEventListener('resize', this.onResize);
	
	        if (this.props.tick) {
	            this.startTick();
	        }
	    },
	
	    componentWillUnmount: function () {
	        window.removeEventListener('resize', this.onResize);
	
	        this.stopTick();
	    },
	
	    componentWillReceiveProps: function (nextProps) {
	        this.setState({
	            width: nextProps.width !== 'auto' ? nextProps.width : this.state.width,
	            height: nextProps.height !== 'auto' ? nextProps.height : this.state.height
	        });
	    },
	
	    componentDidUpdate: function (prevProps) {
	        var tickChanged = prevProps.tick !== this.props.tick;
	        var readyChanged = prevProps.ready !== this.props.ready;
	
	        if (readyChanged && this.props.ready && this.props.tick) {
	            this.startTick();
	        } else if (readyChanged && !this.props.ready && this.props.tick) {
	            this.stopTick();
	        }
	
	        if (tickChanged && this.props.tick) {
	            this.startTick();
	        } else if (tickChanged && !this.props.tick) {
	            this.stopTick();
	        }
	    },
	
	    /**
	     * Methods
	     */
	    getEngineByName: function (name) {
	        var normalizedName = name.replace(/[^a-z0-9]+/gi, '');
	        for (var key in this.props.engines) {
	            if (normalizedName === key.replace(/[^a-z0-9]+/gi, '')) {
	                return this.props.engines[key];
	            }
	        }
	    },
	
	    updateSize: function () {
	        var el = ReactDOM.findDOMNode(this);
	        var parent = el.parentNode;
	        var width = parent.offsetWidth;
	        var height = parent.offsetHeight;
	
	        var newWidth = this.props.width !== 'auto' ? this.props.width : width;
	        var newHeight = this.props.height !== 'auto' ? this.props.height : height;
	
	        var sizeChanged = newWidth !== this.state.width || newHeight !== this.state.height;
	        var size = {
	            width: newWidth,
	            height: newHeight
	        };
	
	        this.setState(size, function () {
	            if (sizeChanged && this.props.onSizeChange) {
	                this.props.onSizeChange(size);
	            }
	        });
	    },
	
	    startTick: function () {
	        this.tickHandle = raf(this.tick);
	    },
	
	    stopTick: function () {
	        if (this.tickHandle) {
	            raf.cancel(this.tickHandle);
	            this.tickHandle = null;
	        }
	    },
	
	    tick: function () {
	        this.tickHandle = raf(this.tick);
	
	        if (this.state.engineTick) {
	            this.state.engineTick();
	        }
	
	        if (this.props.onTick) {
	            this.props.onTick();
	        }
	    },
	
	    /**
	     * Events
	     */
	    onResize: function () {
	        if (this.props.width === 'auto' || this.props.height === 'auto') {
	            this.updateSize();
	        }
	    },
	
	    onEngineReady: function () {
	        this.setState({
	            ready: true
	        });
	
	        if (this.props.onReady) {
	            this.props.onReady.apply(this, arguments);
	        }
	    },
	
	    onEngineTickReady: function (tick) {
	        this.setState({
	            engineTick: tick
	        });
	
	        if (this.props.onTickReady) {
	            this.props.onTickReady(tick);
	        }
	    }
	
	});
	
	module.exports = Canvas;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(6)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 7 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	var Canvas = __webpack_require__(3);
	var PixiEngine = __webpack_require__(10);
	
	var CanvasPixi = React.createClass({
	    displayName: 'CanvasPixi',
	
	
	    getDefaultProps: function () {
	        return {
	            engine: PixiEngine
	        };
	    },
	
	    render: function () {
	        return React.createElement(Canvas, this.props);
	    }
	
	});
	
	module.exports = CanvasPixi;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(4);
	var PIXI = __webpack_require__(11);
	
	var PixiCanvas = React.createClass({
	    displayName: 'PixiCanvas',
	
	
	    propTypes: {
	        width: React.PropTypes.number,
	        height: React.PropTypes.number,
	        rendererOptions: React.PropTypes.object,
	
	        createScene: React.PropTypes.func,
	        createRenderer: React.PropTypes.func,
	
	        onReady: React.PropTypes.func,
	        onTickReady: React.PropTypes.func
	    },
	
	    renderer: null,
	
	    getDefaultProps: function () {
	        return {
	            rendererOptions: {}
	        };
	    },
	
	    getInitialState: function () {
	        return {
	            renderer: null,
	            scene: null
	        };
	    },
	
	    render: function () {
	        return React.createElement(
	            'canvas',
	            null,
	            this.props.children
	        );
	    },
	
	    /**
	     * Life cycle
	     */
	    componentDidMount: function () {
	        var renderer = this.createRenderer();
	        var scene = this.createScene();
	        this.setState({
	            renderer: renderer,
	            scene: scene
	        }, function () {
	            this.onReady();
	        });
	    },
	
	    componentDidUpdate: function (prevProps, prevState) {
	        var sizeChanged = prevProps.width !== this.props.width || prevProps.height !== this.props.height;
	        if (sizeChanged) {
	            this.resize();
	        }
	    },
	
	    /**
	     * Methods
	     */
	    createRenderer: function () {
	        var el = ReactDOM.findDOMNode(this);
	
	        if (this.props.createRenderer) {
	            return this.props.createRenderer(el, this.props.width, this.props.height);
	        }
	
	        var renderer = PIXI.autoDetectRenderer(this.props.width, this.props.height, Object.assign({
	            view: el,
	            transparent: true
	        }, this.props.rendererOptions));
	        return renderer;
	    },
	
	    createScene: function () {
	        if (this.props.createScene) {
	            return this.props.createScene();
	        }
	
	        var scene = new PIXI.Container();
	        return scene;
	    },
	
	    resize: function () {
	        if (this.state.renderer) {
	            this.state.renderer.resize(this.props.width, this.props.height);
	        }
	    },
	
	    tick: function () {
	        if (this.state.renderer && this.state.scene) {
	            this.state.renderer.render(this.state.scene);
	        }
	    },
	
	    /**
	     * Events
	     */
	    onReady: function () {
	        if (this.props.onReady) {
	            this.props.onReady(this.state.renderer, this.state.scene);
	        }
	
	        if (this.props.onTickReady) {
	            this.props.onTickReady(this.tick);
	        }
	    }
	});
	
	module.exports = PixiCanvas;

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }
/******/ ])
});
;
//# sourceMappingURL=pixi.js.map


//////////////////
// WEBPACK FOOTER
// ../~/react-draw/pixi.js
// module id = 882
// module chunks = 0